import { render } from "./RestaurantPage.vue?vue&type=template&id=129728d7"
import script from "./RestaurantPage.vue?vue&type=script&lang=js"
export * from "./RestaurantPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__